import ACTIONS, {
  CLEAR_EKYC_RESULT,
  CLEAR_REMOTE_SELLING_RESULT,
  ENTER_EKYC_F2F,
  REMOTE_SELLING_RESET_DATA,
} from './action-types'

export const resetApplicationFetchUpdate = () => ({
  type: ACTIONS.RESET_APPLICATION_FETCH_UPDATE,
})

export const applicationFetchUpdate = () => ({
  type: ACTIONS.APPLICATION_FETCH_UPDATE,
})

export const applicationFetchUpdateSuccess = () => ({
  type: ACTIONS.APPLICATION_FETCH_UPDATE_SUCCESS,
})

export const applicationFetchUpdateError = (error) => ({
  type: ACTIONS.APPLICATION_FETCH_UPDATE_ERROR,
  payload: { error },
})

export const applicationInstallUpdate = () => ({
  type: ACTIONS.APPLICATION_INSTALL_UPDATE,
})

export const applicationInstallUpdateSuccess = () => ({
  type: ACTIONS.APPLICATION_INSTALL_UPDATE_SUCCESS,
})

export const applicationInstallUpdateError = (error) => ({
  type: ACTIONS.APPLICATION_INSTALL_UPDATE_ERROR,
  payload: { error },
})

export const applicationCheckVersion = () => ({
  type: ACTIONS.APPLICATION_CHECK_VERSION,
})

export const applicationCheckVersionValidVersion = () => ({
  type: ACTIONS.APPLICATION_CHECK_VERSION_VALIDVERSION,
})

export const applicationCheckVersionInvalidVersion = (error) => ({
  type: ACTIONS.APPLICATION_CHECK_VERSION_INVALIDVERSION,
  payload: { error },
})

export const remoteSellingCreateNewLink = () => ({
  type: ACTIONS.REMOTE_SELLING_CREATE_NEW_LINK,
})

export const resetRemoteSellingData = () => ({
  type: ACTIONS.REMOTE_SELLING_RESET_DATA,
})

export const submitRemoteSellingSubmitResumeModal = (sectionName) => ({
  type: ACTIONS.REMOTE_SELLING_SUBMIT_RESUME_MODAL,
  payload: { sectionName },
})

export const enterRemoteSelling = () => ({
  type: ACTIONS.ENTER_REMOTE_SELLING,
})

export const confirmUsingRemoteSelling = () => ({
  type: ACTIONS.CONFIRM_REMOTE_SELLING,
})

export const clearRMSResults = () => ({
  type: ACTIONS.CLEAR_REMOTE_SELLING_RESULT,
})

export const createRemoteSellingCase = () => ({
  type: ACTIONS.CREATE_REMOTE_SELLING_CASE,
})

export const clearEkycResults = (insuredOrPayor) => ({
  type: ACTIONS.CLEAR_EKYC_RESULT,
  payload: { insuredOrPayor },
})

export const enterEkycF2f = (insuredOrPayor) => ({
  type: ACTIONS.ENTER_EKYC_F2F,
  payload: { insuredOrPayor },
})
